import { gql } from "@apollo/client";

export const UpdateUserMutation = gql`
  mutation UpdateUser(
    $username: String!
    $region: AWSRegions!
    $input: ExtendedUpdateUserInput!
  ) {
    updateUser(username: $username, region: $region, input: $input) {
      email
      firstName
      lastName
      username
      groups
      roles
      status
      attributes
      lastLogin
    }
  }
`;
